import type { RouteRecordRaw } from "vue-router";

const WebOrderView = () => import("@views/app/web-order/web-order-view.vue");
const Step1View = () => import("@views/app/web-order/step-1-view.vue");
const Step2View = () => import("@views/app/web-order/step-2-view.vue");
const Step3View = () => import("@views/app/web-order/step-3-view.vue");
const Step4View = () => import("@/app/views/app/web-order/step-4-view.vue");
const Step5View = () => import("@/app/views/app/web-order/step-5-view.vue");
const WebOrderEndView = () => import("@views/app/web-order/web-order-end-view.vue");

export const webOrderRoutes: RouteRecordRaw[] = [
    {
        component: WebOrderView,
        name: "WebOrder_home",
        path: "web-order",
        children: [
            {
                component: Step1View,
                name: "WebOrderStep1",
                path: "step-1/:id",
                props: true,
                meta: {
                    stepId: 1,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep1",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "WebOrderStep2",
                        end: "WebOrderEnd"
                    }
                },
            },
            {
                component: Step2View,
                name: "WebOrderStep2",
                path: "step-2/:id",
                props: true,
                meta: {
                    stepId: 2,
                    buttons: [{ name: "Next", action: "login", label: "Login", visible: true }],
                    navigation: {
                        precheck: "WebOrderStep3",
                        installmentPlan: "WebOrderStep5",
                        installmentPlanMulti: "WebOrderStep5_Multi",
                        end: "WebOrderEnd"
                    }
                }
            },
            {
                component: Step3View,
                name: "WebOrderStep3",
                path: "step-3/:id",
                props: true,
                meta: {
                    stepId: 3,
                    buttons: [{ name: "Next", action: "executePrecheck", label: "Continue", visible: true }],
                    navigation: {
                        nextStep: "WebOrderStep4",
                        end: "WebOrderEnd"
                    }
                }
            },
            {
                component: Step4View,
                name: "WebOrderStep4",
                props: true,
                path: "step-4/:id",
                meta: {
                    stepId: 4,
                    buttons: [{ name: "Next", action: "webNext", label: "Continue", visible: true }],
                    navigation: {
                        nextStep: "WebOrderStep5",
                        end: "WebOrderEnd"
                    }
                }
            },
            {
                component: Step5View,
                name: "WebOrderStep5",
                path: "step-5/:id",
                props: true,
                meta: {
                    stepId: 5,
                    buttons: [{ name: "Next", action: "signApplication", label: "SignApplication", visible: true }],
                    navigation: { 
                        nextStep: "",
                        end: "WebOrderEnd"
                    }
                }
            },
            {
                component: WebOrderEndView,
                name: "WebOrderEnd",
                path: "end/:id",
                props: true,
                meta: {
                    buttons: [{ name: "BackToStore", action: "backToStore", visible: true }],
                    navigation: {}
                }
            },
            {
                name: "ContractRoot",
                path: ":id",
                redirect: {
                    name: "WebOrderStep1"
                }
            }
        ]
    }
];
